import { Card, Col, Flex, Layout, Row } from 'antd'
import { Outlet } from 'react-router-dom'
import Tenant from '../modules/tenant/Tenant'
import { LayoutFooter } from './components/LayoutFooter'

const { Content } = Layout

export const AuthLayout: React.FC = () => {
  return (
    <Layout>
      <Content>
        <Row>
          <Col
            sm={0}
            md={8}
            lg={10}
            style={{
              background: 'url(/assets/auth-bg.png)',
              backgroundSize: 'cover',
              backgroundPosition: 'center',
            }}
          ></Col>
          <Col xs={24} sm={24} md={16} lg={14} style={{ height: '100vh' }}>
            <Flex
              vertical
              style={{
                height: '100%',
              }}
            >
              <Flex flex={1} align="center" justify="center">
                <Card style={{ width: 360 }}>
                  <Flex vertical gap={20} align="center" justify="center">
                    <Tenant.Avatar size={60} />
                    <Outlet />
                  </Flex>
                </Card>
              </Flex>
              <LayoutFooter />
            </Flex>
          </Col>
        </Row>
      </Content>
    </Layout>
  )
}
